import { Button, ButtonProps } from "@mui/material";

const LoginButton = ({variant, color, ...otherProps}: ButtonProps) => <Button variant="contained" color="primary" {...otherProps}>
    Anmelden
</Button>
export default LoginButton;